export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/1e60a33e-259b-41b4-bfaa-b265eae24bc8/images/ec67609ce77d2b9fc24ee20ab0b4b67095446dbb60b6f970c3864bee5d89adbd.jpeg",
  weddingTiered: "https://images.unsplash.com/photo-1769230366307-ed3b9ccb6b4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB3ZWRkaW5nJTIwY2FrZSUyMGVsZWdhbnQlMjBnb2xkJTIwZGV0YWlsfGVufDB8fHx8MTc5MDQzNjA0Mnww&ixlib=rb-4.1.0&q=85",
  grandWedding: "https://images.unsplash.com/photo-1719512037487-78e399b58a53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB3ZWRkaW5nJTIwY2FrZSUyMGVsZWdhbnQlMjBnb2xkJTIwZGV0YWlsfGVufDB8fHx8MTc5MDQzNjA0Mnww&ixlib=rb-4.1.0&q=85",
  themeCrown: "https://static.prod-images.emergentagent.com/jobs/1e60a33e-259b-41b4-bfaa-b265eae24bc8/images/3bca24382f1aaed90ac7a5511a39e9c2ae086d93074488d4d720a7376e915d9e.jpeg",
  birthdaySlice: "https://images.unsplash.com/photo-1557803056-4acbacad87d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwcGFzdGVsJTIwYmlydGhkYXklMjBjYWtlJTIwZmxvd2VycyUyMGJ1dHRlcmNyZWFtfGVufDB8fHx8MTc5MDY4MzgxMXww&ixlib=rb-4.1.0&q=85",
  anniversaryDisplay: "https://static.prod-images.emergentagent.com/jobs/1e60a33e-259b-41b4-bfaa-b265eae24bc8/images/0225b611bb6e8612be4f6cd8a80f040de228a929fda47a7cf85bbd5530f97517.jpeg",
  kidsCastle: "https://images.unsplash.com/photo-1765947379276-8f33ac1b5a94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxraWRzJTIwYmlydGhkYXklMjBjYWtlJTIwY29sb3JmdWwlMjBmb25kYW50fGVufDB8fHx8MTc5MDY4MDkzOHww&ixlib=rb-4.1.0&q=85",
  kidsBluey: "https://static.prod-images.emergentagent.com/jobs/1e60a33e-259b-41b4-bfaa-b265eae24bc8/images/df27a7e185829face776ec017ae5002adb5fdfe242d2c4907dabc339ff36752d.jpeg",
  chocolateTruffle: "https://images.unsplash.com/photo-1700448293876-07dca826c161?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxnb3VybWV0JTIwYXJ0aXNhbiUyMGNha2UlMjBhZXN0aGV0aWMlMjBzbGljZSUyMHBhc3RyeXxlbnwwfHx8fDE3OTA0MzYwNDJ8MA&ixlib=rb-4.1.0&q=85",
  layeredArtisan: "https://images.unsplash.com/photo-1571115177098-24ec42ed204d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxnb3VybWV0JTIwYXJ0aXNhbiUyMGNha2UlMjBhZXN0aGV0aWMlMjBzbGljZSUyMHBhc3RyeXxlbnwwfHx8fDE3OTA0MzYwNDJ8MA&ixlib=rb-4.1.0&q=85",
  cookiesBox: "https://images.unsplash.com/photo-1622467827417-bbe2237067a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxnb3VybWV0JTIwY29va2llcyUyMGJveCUyMGdpZnR8ZW58MHx8fHwxNzkwNDM3NDA5fDA&ixlib=rb-4.1.0&q=85",
  browniesBox: "https://images.unsplash.com/photo-1606313564200-e75d5e30476c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NDk1ODF8MHwxfHNlYXJjaHwyfHxjaG9jb2xhdGUlMjBicm93bmllcyUyMHN0YWNrZWR8ZW58MHx8fHwxNzkwNDM3NDA5fDA&ixlib=rb-4.1.0&q=85",
  cupcakesBox: "https://images.unsplash.com/photo-1677840147161-49e9c1508b0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxjdXBjYWtlcyUyMGJveCUyMGdpZnR8ZW58MHx8fHwxNzkwNDM3NDA5fDA&ixlib=rb-4.1.0&q=85",
  bentoCakeBox: "https://images.unsplash.com/photo-1659679120544-1a968f3003f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4Njk1ODF8MHwxfHNlYXJjaHwxfHxtaW5pJTIwY2FrZSUyMGJveCUyMGdpZnR8ZW58MHx8fHwxNzkwNDM3NDA5fDA&ixlib=rb-4.1.0&q=85",
  styleLambeth: "https://static.prod-images.emergentagent.com/jobs/1e60a33e-259b-41b4-bfaa-b265eae24bc8/images/3bca24382f1aaed90ac7a5511a39e9c2ae086d93074488d4d720a7376e915d9e.jpeg",
  styleFlower: "https://images.unsplash.com/photo-1562777717-dc6984f65a63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxidXR0ZXJjcmVhbSUyMGZsb3dlciUyMGNha2V8ZW58MHx8fHwxNzkwNjg0MDk2fDA&ixlib=rb-4.1.0&q=85",
  stylePearl: "https://images.unsplash.com/photo-1666453581752-988e9e5106f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHx3aGl0ZSUyMHBlYXJsJTIwY2FrZSUyMGVsZWdhbnR8ZW58MHx8fHwxNzkwNjg0MTAyfDA&ixlib=rb-4.1.0&q=85",
  styleRibbon: "https://images.unsplash.com/photo-1768776182433-eff58e44d66d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxjYWtlJTIwd2l0aCUyMHJpYmJvbiUyMGJvdyUyMHBpbmt8ZW58MHx8fHwxNzkwNjg0MTEwfDA&ixlib=rb-4.1.0&q=85",
  styleBeach: "https://static.prod-images.emergentagent.com/jobs/1e60a33e-259b-41b4-bfaa-b265eae24bc8/images/10ee6bc5001f9c0cc9d2d6717e91a24ecd407b5cd33f6618ed2ae7074c2d3287.jpeg",
  styleLily: "https://static.prod-images.emergentagent.com/jobs/1e60a33e-259b-41b4-bfaa-b265eae24bc8/images/a65a67e79bffae6a42f321790d4957160d2bc41b8131f7803866cb15bb442170.jpeg",
  styleWaferPaper: "https://static.prod-images.emergentagent.com/jobs/1e60a33e-259b-41b4-bfaa-b265eae24bc8/images/7aa4f3717c788936e5d54d7d83df93dbfbc5258bcabafb0e57e58eead38d5908.jpeg",
  founder: "https://customer-assets-39nsmqrw.emergentagent.net/job_tarah-creations/artifacts/0u08n65n_WhatsApp%20Image%202026-09-29%20at%2012.52.05.jpeg",
};

export const IMAGE_LABELS = {
  hero: "Homepage hero cake",
  themeCrown: "Theme cakes photo (menu)",
  birthdaySlice: "Birthday cakes photo (menu + gallery)",
  anniversaryDisplay: "Anniversary cakes photo (menu + gallery)",
  kidsBluey: "Kids Collections photo (menu) — Bluey cake",
  kidsCastle: "Gallery — Kids castle cake",
  cookiesBox: "Gift — Cookie Box",
  browniesBox: "Gift — Brownie Box",
  cupcakesBox: "Gift — Celebration Cupcake Box",
  bentoCakeBox: "Gift — Bento Cake & Cupcakes Box",
  styleLambeth: "Theme style — Lambeth Vintage",
  styleFlower: "Theme style — Flower Cake",
  stylePearl: "Theme style — Pearl Theme",
  styleRibbon: "Theme style — Ribbon Cake",
  styleBeach: "Theme style — Beach Theme",
  styleLily: "Theme style — Lily Cake",
  styleWaferPaper: "Theme style — Wafer Paper",
  founder: "Founder portrait (story page)",
};

export const MARQUEE_ITEMS = [
  "Custom Birthday Cakes",
  "Kids Cakes",
  "Theme & Vintage Cakes",
  "Bento Cake Gift Boxes",
  "Brownies, Cookies & Cupcakes",
  "Made to Order",
  "Freshly Baked",
  "Baked with Love",
];

export const MENU = [
  {
    id: "birthday",
    name: "Birthday Cakes",
    eventType: "Birthday Cake",
    tagline: "Made for your special day",
    image: "birthdaySlice",
    fromPrice: "€75",
    priceNote: "Photos are for reference only — prices may vary depending on the design and the detail work involved. We confirm you the exact price with your quote.",
    serves: "6, 7 & 8 inch — 4 layers",
    description:
      "A four-layer sponge in vanilla or chocolate, filled with your choice of Nutella, pistachio or Lotus Biscoff and finished in smooth buttercream. Choose your colours and add a name or message — every cake is made fresh to order.",
    tiers: [
      { name: "6 Inch Cake — 4 Layer", serves: "Serves 10–14", price: "€75" },
      { name: "7 Inch Cake — 4 Layer", serves: "Serves 16–20", price: "€105" },
      { name: "8 Inch Cake — 4 Layer", serves: "Serves 22–28", price: "€135" },
    ],
    flavors: ["Vanilla", "Chocolate"],
    fillings: ["Nutella", "Pistachio", "Lotus Biscoff"],
    allergens: ["Gluten (wheat)", "Eggs", "Milk", "Soya", "Nuts (pistachio / hazelnut fillings)"],
  },
  {
    id: "theme",
    name: "Theme Cakes",
    eventType: "Theme Cake",
    tagline: "Your idea, made in cake",
    image: "themeCrown",
    fromPrice: "€95",
    priceNote: "Photos are for reference only — prices may vary depending on the design and the detail work involved. We confirm your exact price with your quote.",
    serves: "6, 7 & 8 inch — 4 layers",
    description:
      "Tap a style below to see a reference photo, or bring your own idea. Our Lambeth vintage cakes feature hand-piped buttercream ruffles, shells, garlands and pearls; flower, lily and wafer-paper designs add a soft botanical touch; pearl, ribbon and beach themes are perfect for elegant or playful celebrations.",
    styles: [
      { name: "Lambeth Vintage", image: "styleLambeth" },
      { name: "Flower Cake", image: "styleFlower" },
      { name: "Pearl Theme", image: "stylePearl" },
      { name: "Ribbon Cake", image: "styleRibbon" },
      { name: "Beach Theme", image: "styleBeach" },
      { name: "Lily Cake", image: "styleLily" },
      { name: "Wafer Paper", image: "styleWaferPaper" },
    ],
    tiers: [
      { name: "6 Inch Cake — 4 Layer", serves: "Serves 10–14", price: "€95" },
      { name: "7 Inch Cake — 4 Layer", serves: "Serves 16–20", price: "€125" },
      { name: "8 Inch Cake — 4 Layer", serves: "Serves 22–28", price: "€155" },
    ],
    flavors: ["Vanilla", "Chocolate"],
    fillings: ["Nutella", "Pistachio", "Lotus Biscoff"],
    allergens: ["Gluten (wheat)", "Eggs", "Milk", "Soya", "Nuts (pistachio / hazelnut fillings)"],
  },
  {
    id: "anniversary",
    name: "Anniversary Cakes",
    eventType: "Anniversary Cake",
    tagline: "Celebrate the years together",
    image: "anniversaryDisplay",
    fromPrice: "€75",
    priceNote: "Photos are for reference only — prices may vary depending on the design and the detail work involved. We confirm your exact price with your quote.",
    serves: "6, 7 & 8 inch — 4 layers",
    description:
      "Elegant, simple anniversary cakes with a personal touch — your initials, your date or a short message, finished with piped detail, fresh flowers or a soft colour of your choice.",
    tiers: [
      { name: "6 Inch Cake — 4 Layer", serves: "Serves 10–14", price: "€75" },
      { name: "7 Inch Cake — 4 Layer", serves: "Serves 16–20", price: "€105" },
      { name: "8 Inch Cake — 4 Layer", serves: "Serves 22–28", price: "€135" },
    ],
    flavors: ["Vanilla", "Chocolate"],
    fillings: ["Nutella", "Pistachio", "Lotus Biscoff"],
    allergens: ["Gluten (wheat)", "Eggs", "Milk", "Soya", "Nuts (pistachio / hazelnut fillings)"],
  },
  {
    id: "kids",
    name: "Kids Collections",
    eventType: "Kids Cake",
    tagline: "Fun cakes for little ones",
    image: "kidsBluey",
    fromPrice: "€75",
    priceNote: "Photos are for reference only — prices may vary depending on the design and the detail work involved. We confirm your exact price with your quote.",
    serves: "6, 7 & 8 inch — 4 layers",
    description:
      "Bluey, castles, superheroes, unicorns, dinosaurs and favourite characters — colourful cakes made for little celebrations. Tell us their favourite theme and colours and we will add a name and age to finish it off.",
    tiers: [
      { name: "6 Inch Cake — 4 Layer", serves: "Serves 10–14", price: "€75" },
      { name: "7 Inch Cake — 4 Layer", serves: "Serves 16–20", price: "€105" },
      { name: "8 Inch Cake — 4 Layer", serves: "Serves 22–28", price: "€135" },
    ],
    flavors: ["Vanilla", "Chocolate"],
    fillings: ["Nutella", "Pistachio", "Lotus Biscoff"],
    allergens: ["Gluten (wheat)", "Eggs", "Milk", "Soya", "Nuts (pistachio / hazelnut fillings)", "May contain food colourings"],
  },
];

export const GALLERY = [
  { id: "g1", src: "birthdaySlice", title: "Birthday Cake", category: "Birthday", detail: "Four-layer vanilla sponge with silk buttercream, fresh berries and a gold-dusted finish." },
  { id: "g2", src: "kidsCastle", title: "Kids Cake", category: "Kids", detail: "Hand-sculpted castle cake with turrets, sugar details and a personalised name plaque." },
  { id: "g3", src: "anniversaryDisplay", title: "Anniversary Cake", category: "Anniversary", detail: "Elegant anniversary cake finished with hand-piped detailing and fresh blooms." },
];

export const GIFTS = [
  {
    id: "cookies",
    name: "Cookie Box",
    price: "€32",
    image: "cookiesBox",
    description: "Twelve freshly baked cookies — chocolate chunk and vanilla — in a simple gift box.",
  },
  {
    id: "brownies",
    name: "Brownie Box",
    price: "€36",
    image: "browniesBox",
    description: "Nine rich chocolate brownies, hand-cut and boxed. Add a Nutella, pistachio or Biscoff topping if you like.",
  },
  {
    id: "cupcakes",
    name: "Celebration Cupcake Box",
    price: "€42",
    image: "cupcakesBox",
    description: "Six vanilla or chocolate cupcakes with buttercream swirls in the colours of your celebration.",
  },
  {
    id: "bento",
    name: "Bento Cake & Cupcakes Box",
    price: "€58",
    image: "bentoCakeBox",
    description: "A small bento cake with a piped message, paired with four matching cupcakes — a lovely gift box.",
  },
];

export const FAQS = [
  {
    q: "How far in advance should I order?",
    a: "Please allow at least 2 weeks for custom cakes and 3–5 days for bento boxes, cupcakes, cookies and brownies. If you need something sooner, send an enquiry and we will let you know if it is possible.",
  },
  {
    q: "What flavours and fillings do you offer?",
    a: "We keep it simple: vanilla or chocolate sponge, with a choice of Nutella, pistachio or Lotus Biscoff filling.",
  },
  {
    q: "Do you list allergens?",
    a: "Yes. Allergens are shown under each cake category on the menu. All items are made in a kitchen that handles gluten, eggs, milk, soya and nuts, so we cannot guarantee any product is free from traces. Please tell us about allergies when you enquire.",
  },
  {
    q: "Do you deliver?",
    a: "Cakes are collected from Drogheda, Co. Louth. Local delivery may be available on request — ask when you enquire and we will confirm the cost.",
  },
  {
    q: "How do payments work?",
    a: "A 50% deposit confirms your order and the balance is due before collection. We currently accept bank transfer and Revolut; details are sent with your quote.",
  },
  {
    q: "Can I send inspiration photos?",
    a: "Please do. Describe your theme, colours and ideas in the enquiry form and we will design something inspired by them.",
  },
];

export const CONTACT = {
  email: "enquiries@tarah.ie",
  phone: "+353 89 258 0705",
  address: "24 Usher's Mill Rise, Usher's Mill, Drogheda, Co. Louth, A92 FRP4",
  hours: "Orders by enquiry - collection in Drogheda. Delivery available on request",
};

export const BUSINESS = {
  legal:
    "Tarah — Cake Design Studio · Home-based food business · 24 Usher's Mill Rise, Usher's Mill, Drogheda, Co. Louth, A92 FRP4",
};

export const EXTRAS = [
  { id: "candles", name: "Special Candle Pack", detail: "Pack of 2", price: "€1" },
  { id: "topper", name: "Customised Topper", detail: "Name, age or message", price: "€3 – €8" },
  { id: "knife", name: "Cake Knife", detail: "So you're ready to cut", price: "€2.50" },
];

export const PAYMENT = {
  revolutLink: "",
  depositNote: "Please wait until Thara has confirmed your date and price before paying the deposit.",
};

export const DEFAULT_CONTENT = JSON.parse(
  JSON.stringify({ images: IMAGES, menu: MENU, gifts: GIFTS, extras: EXTRAS, payment: PAYMENT })
);

export const applySiteContent = (data) => {
  if (!data) return;
  if (data.images && typeof data.images === "object") Object.assign(IMAGES, data.images);
  if (Array.isArray(data.menu) && data.menu.length) MENU.splice(0, MENU.length, ...data.menu);
  if (Array.isArray(data.gifts) && data.gifts.length) GIFTS.splice(0, GIFTS.length, ...data.gifts);
  if (Array.isArray(data.extras) && data.extras.length) EXTRAS.splice(0, EXTRAS.length, ...data.extras);
  if (data.payment && typeof data.payment === "object") Object.assign(PAYMENT, data.payment);
};
